import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
import { WprControlInfo } from '../wpr-framework/view/control/WprControlInfo';
import * as holiday_jp from '@holiday-jp/holiday_jp';

export class Calender {
	// private 変数  ------------------------------------------------------------
	private m_ViewCore: WprBaseViewCore 	= null;			// ビュー情報
	private m_Control: WprControlInfo		= null;			// 日付コントロール情報
	private m_Settings: any					= null;			// 日付設定情報
	// --------------------------------------------------------------------------

	// pubilc メソッド  ----------------------------------------------------------
	/**
	 * 初期化処理
	 * @param viewCore ビュー情報
	 * @param name 日付コントロール名
	 * @param today 本日日付
	 * @param startDate 開始日付
	 * @param endDate 終了日付
	 * @returns カレンダー
	 */
	public static init(viewCore: WprBaseViewCore, name: string, today:Date, startDate: Date, endDate: Date): Calender {
		const calender = new Calender(viewCore, name, today, startDate, endDate);
		return calender;
	}
	// --------------------------------------------------------------------------

	// コンストラクタ	----------------------------------------------------------
	constructor(viewCore: WprBaseViewCore, name: string, today: Date, startDate: Date, endDate: Date) {
		this.m_Control = viewCore.getControlInfo(name);
		this.m_ViewCore = viewCore;
		const element: any = $(`input[name='${name}']`);
		this.m_Settings = {
			format: 'yyyy/mm/dd',
			min: startDate,
			max: endDate,
			today: '',
			clear: '',
			close: 'カレンダーを閉じる',
			monthsFull: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			weekdaysFull: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
			weekdaysShort: ['　日　', '　月　', '　火　', '　水　', '　木　', '　金　', '　土　'],
			now: today,
			changeEvent: this.onChangeDate.bind(this),
			checkHoliday: this.checkHoliday.bind(this)
		};
		element.pickadate(this.m_Settings);
	}
	// --------------------------------------------------------------------------

	// public メソッド  ----------------------------------------------------------
	/**
	 * 開始日、終了日設定
	 * @param startDate 開始日
	 * @param endDate 終了日
	 */
	public setDate(startDate: Date, endDate: Date): void {
		this.m_Settings.options.minDate = startDate;
		this.m_Settings.options.maxDate = endDate;
	}

	/**
	 * 祝日チェック
	 * @returns tureの場合、祝日
	 */
	public checkHoliday(date: any): boolean {
		return holiday_jp.isHoliday(date.obj);
	}
	// --------------------------------------------------------------------------

	// private メソッド  ---------------------------------------------------------
	/**
	 * 日付変更通知処理
	 * @param date 日付
	 */
	private onChangeDate(date: string) {
		this.m_Control.value = date;
		this.m_ViewCore.onChangeValue(this.m_Control.name, date);
	}
	// --------------------------------------------------------------------------
}